<template>
<div class="modal animated is-active">
  <div class="modal-background"></div>
  <div class="modal-card is-large">
    <header class="modal-card-head">
      <p class="modal-card-title">{{title}}</p>
    </header>
    <section class="modal-card-body">
      <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
      <p class="control">
        <label class="label">Services: {{migration.services}}</label>
        <label class="label">Payments: {{migration.payments}}</label>
      </p>
      <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
      <div class="control is-vertical">
        <div class="control is-grouped">
          <p class="control">
            <input class="input" name="new_provider" id="new_provider" type="text" placeholder="" v-model="new_provider" style="width: 50px;">
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true}" @click="filter()">Filter</a>
          </p>
          <p class="control is-expanded">
            <select class="select is-fullwidth" v-model="new_provider_id" name="new_provider_id" id="new_provider_id" @change="setProvider()">
              <option v-for="provider in providers" v-bind:value="provider.id" v-if="provider.name.trim() != ''">{{ provider.id + ' - ' + provider.name + '(' + provider.provider_id + ')' }}</option>
            </select>
          </p>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <div class="control is-grouped is-pulled-right">
        <p class="control is-pulled-right">
          <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close()">Cancel</a>
        </p>
        <p class="control">
          <a :class="{'button': true, 'is-success': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="migrate()">Migrate</a>
        </p>
      </div>
    </footer>
  </div>
</div>
</template>
<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      provider_id: {
        type: Number,
        default: null
      }
    },
    data () {
      return {
        provider: {
        },
        migration: '',
        error: '',
        inProgress: false,
        old_provider_id: '',
        new_provider_id: '',
        providers: [],
        new_provider: '',
        next: false
      }
    },
    beforeMount () {
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.loadProviders()
        document.body.appendChild(this.$el)
        this.old_provider_id = this.provider_id
      })
    },
    methods: {
      filter () {
        this.new_provider_id = this.new_provider
        this.next = true
      },
      setProvider () {
        this.new_provider = this.new_provider_id
        this.next = true
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/checkMigration/' + this.provider_id).then((response) => {
          this.migration = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      loadProviders () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/active').then((response) => {
          this.providers = response.body
        }, (response) => {

        })
      },
      migrate () {
        this.$validator.validateAll()
        this.inProgress = true
        this.error = ''
        this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/migrate', { old_provider_id: this.old_provider_id, new_provider_id: this.new_provider_id }).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The Provider ' + response.body.name + ' was successfully migrated'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      close () {
        this.$el.remove()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }
  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// ProviderMigration.vue?67f43015